import Wasm from "~/wasm/wasm";
import { IWasmStoreMarker, TMarkerVisualType } from "../store/interfaces";
import WasmMapMarker from "./wasm-map-marker";

// typy markeru - zarizeni, fotka, fotka s radiusem, fotka + radius + sipka
export default class WasmMapMarkerSharedPosition {
	#radiusMarker: WasmMapMarker | null;

	#arrowMarker: WasmMapMarker | null;

	#mainMarker: WasmMapMarker;

	constructor(wasm: Wasm, data: IWasmStoreMarker) {
		this.#radiusMarker = null;
		this.#arrowMarker = null;

		// mame radius
		if (data.customData?.radius) {
			this.#radiusMarker = new WasmMapMarker(wasm, {
				...data,
				// furt standard
				visual: "standard",
				interactionType: "none",
			}, {
				customTexture: "position-share-image-radius",
			});
		}

		// mame sipku
		if (data.type === "position-share-arrow") {
			this.#arrowMarker = new WasmMapMarker(wasm, {
				...data,
				// furt standard
				visual: "standard",
				interactionType: "none",
			}, {
				customTexture: "position-share-image-arrow",
			});
		}

		// marker s obrazkem nebo zarizenim
		this.#mainMarker = new WasmMapMarker(wasm, {
			...data,
			angle: 0,
		}, {
			customTexture: data.customData?.order
				? "position-share-device"
				: "position-share-image",
		});
	}

	destroy() {
		this.#radiusMarker?.destroy();
		this.#arrowMarker?.destroy();
		this.#mainMarker.destroy();
	}

	setPosition(wgsLon: number, wgsLat: number) {
		this.#radiusMarker?.setPosition(wgsLon, wgsLat);
		this.#arrowMarker?.setPosition(wgsLon, wgsLat);
		this.#mainMarker.setPosition(wgsLon, wgsLat);
	}

	setVisual(visual: TMarkerVisualType) {
		this.#mainMarker.setVisual(visual);
	}

	get wasmIds() {
		return [
			...this.#radiusMarker ? this.#radiusMarker.wasmIds : [],
			...this.#arrowMarker ? this.#arrowMarker.wasmIds : [],
			...this.#mainMarker.wasmIds,
		];
	}

	setVisibility(visible: boolean) {
		this.#radiusMarker?.setVisibility(visible);
		this.#arrowMarker?.setVisibility(visible);
		this.#mainMarker.setVisibility(visible);
	}

	setAngle(angle: number) {
		// pouze sipka
		this.#arrowMarker?.setAngle(angle);
	}

	setBringToTheFront(bringToTheFront: boolean) {
		this.#radiusMarker?.setBringToTheFront(bringToTheFront);
		this.#arrowMarker?.setBringToTheFront(bringToTheFront);
		this.#mainMarker.setBringToTheFront(bringToTheFront);
	}
}
